
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import busCartoon from "@/assets/parents-bus-cartoon.png";
import explorerKid from "@/assets/parents-explorer-kid.png";

const features = [
  {
    num: 1,
    color: "bg-purple-400",
    title: "Limitless Play & Learning",
    desc: "Explore, play, and learn with games, songs, and activities for kids 2-8! Discover Math, Science, Art, and more in a fun learning adventure!",
  },
  {
    num: 2,
    color: "bg-red-400",
    title: "Safe and Ad-Free",
    desc: "Designed with your child's safety in mind, our platform is 100% ad-free. Enjoy a secure, worry-free learning environment where kids can explore and grow with confidence.",
  },
  {
    num: 3,
    color: "bg-sky-400",
    title: "Multi-Device Access",
    desc: "One App, Four Kids! Your family can enjoy the platform across phones, tablets and more. Each child can explore their own learning journey!",
  },
  {
    num: 4,
    color: "bg-rose-400",
    title: "Interactive, Screen-Free Learning",
    desc: "Engaging audio and hands-on activities let kids learn and play—no screen needed! Explore, discover, and have fun anywhere, anytime.",
  },
];

const ParentsSection = () => {
  return (
    <section className="py-16 bg-white relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          {/* Left - Bus cartoon */}
          <motion.div
            className="w-full lg:w-5/12 flex justify-center"
            initial={{ x: -40, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <img
              src={busCartoon}
              alt="Cartoon school bus with happy kids and animal characters"
              className="w-full max-w-[480px] h-auto drop-shadow-lg"
              loading="lazy"
              width={800}
              height={800}
            />
          </motion.div>

          {/* Right - Features */}
          <motion.div
            className="w-full lg:w-7/12"
            initial={{ x: 40, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            <p className="text-sm font-bold tracking-widest text-sky-500 uppercase mb-2">
              Unlimited Learning
            </p>
            <h2 className="text-3xl md:text-4xl font-fredoka font-bold text-gray-800 leading-tight mb-8">
              We nurture knowledge and build essential life skills
            </h2>

            <div className="space-y-6 relative">
              {features.map((f, i) => (
                <motion.div
                  key={f.num}
                  className="flex items-start gap-4"
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.1 * i, duration: 0.4 }}
                >
                  <div
                    className={`${f.color} text-white w-11 h-11 rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0 shadow-md border-2 border-dashed border-white/60`}
                  >
                    {f.num}
                  </div>
                  <div>
                    <h3 className="text-lg font-fredoka font-bold text-gray-800 mb-1">
                      {f.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {f.desc}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>

            <div className="mt-8 flex items-end gap-4">
              <Link
                to="/about"
                className="inline-block bg-gray-800 hover:bg-gray-900 text-white font-fredoka font-bold text-base px-8 py-3.5 rounded-full transition-colors shadow-lg"
              >
                Read More
              </Link>
              {/* Explorer kid mascot */}
              <img
                src={explorerKid}
                alt="Explorer kid mascot"
                className="w-20 h-20 object-contain hidden sm:block"
                loading="lazy"
                width={512}
                height={512}
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ParentsSection;
